import { render } from "./extended.vue?vue&type=template&id=2c51ae8e"
import script from "./extended.vue?vue&type=script&lang=js"
export * from "./extended.vue?vue&type=script&lang=js"

import "./extended.vue?vue&type=style&index=0&id=2c51ae8e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__